import $ from "jquery";

const layoutSlickAndInteractions = function () {
  $(".sldier_marquee_outers").slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: "linear",
    slidesToShow: 1,
    draggable: false,
    focusOnSelect: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
  });

  function callslick() {
    $(".bm-section.bm-section-3 .blockWrap").slick({
      responsive: [
        {
          breakpoint: 9999,
          settings: "unslick",
        },
        {
          breakpoint: 780,
          settings: {
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });
  }

  callslick();

  $(window).on("resize", function () {
    callslick();
  });

  $(".linkCta").click(function () {
    var linkCta = $(this).attr("linkCta");
    window.location.href = linkCta;
  });

  $(".tabDetails h3.head").click(function () {
    if ($(this).hasClass("active")) {
      $(".tabDetails h3.head").removeClass("active");
      $(".descrip").slideUp();
    } else {
      $(".tabDetails h3.head").removeClass("active");
      $(".descrip").slideUp();
      $(this).addClass("active");
      $(this).next(".descrip").slideDown();
    }
  });

  $(".site-header__nav .nav__item.m-level-1").mouseenter(function () {
    $("body.template-page-beastmode").addClass("admnus megamenu-open");
  });

  $(".site-header__nav .nav__item.m-level-1").mouseleave(function () {
    $("body.template-page-beastmode").removeClass("admnus megamenu-open");
  });
};

export default layoutSlickAndInteractions;
